(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sa-klaviyo-bis"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__saKlaviyoBisBound) return;
    window.__saKlaviyoBisBound = true;

    function bindKlaviyoBisHover() {
      var HoverButton = window.theme && window.theme.HoverButton;
      if (!HoverButton) return;

      document.querySelectorAll('[data-sa-klaviyo-bis]:not([data-sa-bis-hover])').forEach(function (el) {
        el.setAttribute('data-sa-bis-hover', '');
        new HoverButton(el).load();
      });
    }

    function openKlaviyoForm(formId) {
      if (!formId) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }

    document.addEventListener('click', function (event) {
      var root = event.target.closest('[data-sa-klaviyo-bis]');
      if (!root || root.hidden) return;
      event.preventDefault();
      openKlaviyoForm(root.getAttribute('data-klaviyo-form-id'));
    });

    if (window.theme && window.theme.HoverButton) {
      bindKlaviyoBisHover();
    } else {
      window.addEventListener('load', bindKlaviyoBisHover);
    }

    document.addEventListener('variant:change', bindKlaviyoBisHover, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
